import { Porto, Mode } from "porto";
import { hostUrls } from "porto/core/Dialog";
import type { Address } from "viem";

// Porto instance
export const porto = Porto.create({
  mode: Mode.dialog({ host: hostUrls.prod }),
  storageKey: "porto.store.v3",
});

// Wallet state using Svelte 5 runes
class WalletState {
  connected = $state(false);
  address = $state<Address | null>(null);
  error = $state<string | null>(null);
  loading = $state(false);

  get shortAddress() {
    if (!this.address) return null;
    return `${this.address.slice(0, 6)}...${this.address.slice(-4)}`;
  }

  async connect() {
    this.loading = true;
    this.error = null;

    try {
      const result = await porto.provider.request({
        method: "wallet_connect",
      });

      const accounts = result.accounts;
      const firstAccount = accounts?.[0];

      if (firstAccount) {
        this.connected = true;
        this.address = firstAccount.address;
      }
    } catch (err) {
      this.error = err instanceof Error ? err.message : "Connection failed";
      this.connected = false;
      this.address = null;
    } finally {
      this.loading = false;
    }
  }

  async disconnect() {
    try {
      await porto.provider.request({ method: "wallet_disconnect" });
    } catch {
      // Ignore disconnect errors
    }

    this.connected = false;
    this.address = null;
    this.error = null;
  }
}

export const wallet = new WalletState();
